module.exports = function() {
  return new Worker(__webpack_public_path__ + "5b3cc808e8d1065f6ddb.worker.js");
};